var _rect, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "users_svg__a",
    x: 0.304,
    y: 0,
    width: 194.012,
    height: 193.996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.197
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6741_35317"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.021
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.19
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0287811 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_6741_35317",
    result: "effect2_dropShadow_6741_35317"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_6741_35317",
    result: "effect3_dropShadow_6741_35317"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_6741_35317",
    result: "shape"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "users_svg__currentLayer"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#users_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.384 60.213a11.704 11.704 0 01-3.29-3.239c-.88-1.296-1.502-2.76-1.829-4.305a105.563 105.563 0 01-.441-41.287c.293-1.535.88-2.99 1.728-4.277 1.752-2.647 4.444-4.458 7.49-5.042a105.626 105.626 0 0141.296-.05l-.005.011c1.527.296 2.987.894 4.302 1.762a11.726 11.726 0 013.287 3.244 12.2 12.2 0 011.827 4.305 105.64 105.64 0 01.44 41.283 11.734 11.734 0 01-1.727 4.278c-1.755 2.647-4.448 4.458-7.497 5.042a105.664 105.664 0 01-41.288.045 11.914 11.914 0 01-4.293-1.77z",
    fill: "#F8D374"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.696 36a6.5 6.5 0 100-13 6.5 6.5 0 000 13z",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.123 23.242a6.497 6.497 0 017.255 2.78 6.495 6.495 0 01.738 5.333 6.514 6.514 0 01-3.537 4.06 6.505 6.505 0 01-2.693.584M17.695 40.675a11.003 11.003 0 0118-.001M36.886 36a10.987 10.987 0 019 4.674",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgUsers;